import { render } from "./socialMedia.vue?vue&type=template&id=0e289cfc"
import script from "./socialMedia.vue?vue&type=script&lang=js"
export * from "./socialMedia.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__